const styles = {
  iconBackground:
    'bg-black-light rounded-full aspect aspect-1-1 group-hover:bg-gray-1',
  iconFlexWrapper: 'w-full h-full flex items-center justify-center',
  iconWidthWrapper: 'w-2/5 h-2/5',
  title: 'text-center mt-2 md:mt-4 text-body2 font-semibold text-gray-3',
};

export default styles;
